import { useEffect } from "react";
import { useLocation } from "wouter";
import { api } from "./api";
import { useAuth } from "./auth";

/**
 * v3.9.40 (CEO #9) — redirect a signed-in member who hasn't accepted the
 * data-sharing consent to the focused /welcome recovery prompt. Fetches fresh on mount, so
 * right after accepting (which flips it server-side) the page it lands on won't
 * bounce back. Call at the top of gated pages (Dashboard, PostFlow).
 */
export function useConsentGate() {
  const { user } = useAuth();
  const [, navigate] = useLocation();
  useEffect(() => {
    if (!user) return;
    // v3.9.51 — super admins never see the member consent flow; they're routed to
    // the Admin dashboard instead of the member dashboard (see Dashboard/Login).
    if (user.userType === "admin") return;
    let alive = true;
    api.onboardingStatus().then((s) => { if (alive && s?.needsConsent) navigate("/welcome"); }).catch(() => {
      // Welcome owns the existing status-error retry screen; a failed lookup cannot establish consent.
      if (alive) navigate("/welcome");
    });
    return () => { alive = false; };
  }, [user?.id]);
}
